import { createListenerMiddleware } from '@reduxjs/toolkit';
import { searchAttendeesStatsByEvent } from 'src/redesign/features/AttendeeStats/actions';
import { searchAttendeesByEvent } from 'src/redesign/features/Attendees/store/actions';
import { eventsFiltersSlice } from '../../EventsFilters/reducer';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: eventsFiltersSlice.actions.setFiltersData,
  effect: async (_, listenerApi) => {
    const filters = listenerApi.getState()?.eventsFilters?.filtersData;
    const eventId = listenerApi.getState()?.events.currentEvent?.id;

    // Only dispatch if eventId exists to prevent unnecessary API calls
    if (!eventId) {
      console.warn('Stats and search calls skipped: eventId is missing');
      return;
    }

    await listenerApi.dispatch(
      searchAttendeesStatsByEvent({ eventId: eventId, criteria: filters }),
    );
    await listenerApi.dispatch(searchAttendeesByEvent({ eventId: eventId, criteria: filters }));
    // listenerApi.unsubscribe();
  },
});

// Removed duplicate listener that was causing redundant searchAttendeesByEvent calls
// The search is already called by the setFiltersData listener above
